/** Copyright (c) 2025 DAIA Tech Pvt Ltd. All rights reserved.
 *
 * This software is confidential and proprietary information of DAIA Tech Pvt Ltd
 * and its licensors. You shall not disclose such Confidential Information and shall
 * use it only in accordance with the terms of the license agreement.
 *
 * Unauthorized reproduction, modification, distribution, or disclosure of this
 * software is strictly prohibited.
 */

import { Box } from '@chakra-ui/react';
import { PlatformVideoComponent } from '@karya/core';
import { ParsedParams } from '@karya/generic-task-react';

export function PlatformVideoRenderer({ params }: { params?: ParsedParams<any> }) {
  const typedParams = params as ParsedParams<PlatformVideoComponent> | undefined;
  const url = typedParams?.video ?? '/sample_video.webm';
  return <Box as="video" maxH="350px" src={url} controls />;
}
